import React from 'react'
import { Option } from 'Types/Attribute.types'
import { PanelHeader } from 'Components/common/TaskPanelHeader/TaskPanelHeader'
import InfoCircle from 'Assets/icons/info-circle.svg'
import styles from './TaskInformation.module.less'
import CopyButton from 'Components/common/CopyButton/CopyButton'

type TaskInformationProps = {
    informationList: Option[]
    title: string
    expertDetails: {
        id: string
        stepName: string
    }[]
}

const TaskInformation: React.FC<TaskInformationProps> = props => {
    return (
        <div className={styles['task-information']} data-testid="task-information-container">
            <PanelHeader title={props.title} logo={InfoCircle} />
            <div className={styles['task-information-content']}>
                {props.informationList.map(list => (
                    <div className={styles['task-information-content-list']} key={list.label}>
                        <span className={styles['task-information-content-list-first']}>
                            {list.label}
                        </span>
                        <span className={styles['task-information-content-list-second']}>
                            {list.value}
                            <CopyButton
                                contentToCopy={list.value}
                                showTooltip
                                copySuccessMessage="ID copied"
                                tooltipTitle={`Copy ${list.label}`}
                            />
                        </span>
                    </div>
                ))}
                {props.expertDetails.map(expert => (
                    <div className={styles['task-information-content-list']} key={expert.id}>
                        <span className={styles['task-information-content-list-first']}>
                            {expert.stepName} ID
                        </span>
                        <span className={styles['task-information-content-list-second']}>
                            <span>{expert.id}</span>
                            <CopyButton
                                contentToCopy={expert.id}
                                showTooltip
                                copySuccessMessage="ID copied"
                                tooltipTitle={`Copy ${expert.stepName} ID`}
                            />
                        </span>
                    </div>
                ))}
            </div>
        </div>
    )
}
export default TaskInformation
